import { Search } from "lucide-react";

import { CreatePlaylistModal } from "./create-playlist-modal";

export function NoPlaylists() {
  return (
    <div className="flex flex-col items-center justify-center p-12 text-center">
      <div className="mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-card">
        <Search className="h-8 w-8 text-muted-foreground" />
      </div>
      <h2 className="mb-2 text-xl font-semibold text-foreground">
        No playlists found
      </h2>
      <p className="mb-4 max-w-md text-muted-foreground">
        We couldn't find any playlists matching your search criteria.
      </p>
      <CreatePlaylistModal isEmpty={true} variant="outline" />
    </div>
  );
}
